import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import {
  createReduxHistory,
  routerMiddleware,
  employerSide
} from './routerHistory'
//import createOidcMiddleware from 'redux-oidc'
import createSagaMiddleware from 'redux-saga'
import storage from 'redux-persist/lib/storage/session' // saving in sessionStorage
import reducers from './reducers'
import reducers_employer from './reducers/employer'
import createLogger from 'redux-logger'
//import userManager from './utils/PHZUserManager'
import rootSaga from './sagas'
import rootSaga_employer from './sagas/employer'

/**
 * @author Pragya Gupta
 */
const logger = createLogger()

// create the middleware with the userManager
//const oidcMiddleware = createOidcMiddleware(userManager)

const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const createStoreWithMiddleware = composeEnhancers(
  applyMiddleware(logger, sagaMiddleware),
  //must apply routerMiddleware after sagaMiddleware
  //for redux-first-history to intercept dispatched actions
  applyMiddleware(routerMiddleware)
)(createStore)

const initialState = {
  form: {
    invoice: {
      values: {
        amount: 0,
        unitPrice: 0,
        dueDate: '30.03.2017',
        overdue: 14,
        rows: []
      }
    },
    invoiceReview: {
      values: {}
    },
    newallowance: {
      values: {
        meal_allowance: 0,
        full_time_allowance: 0,
        part_time_allowance: 0,
        allowanceInputRow: [],
        allowancePassenger: []
      }
    },
    newfee: {
      values: {
        expenseInputRow: []
      }
    },
    yel: {
      values: {
        income: 0
      }
    },
    decisionDialog: {
      values: {
        decisionSelect: 'add_to_invoice',
        invoice_group: ''
      }
    }
  }
}

// redux persist
const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['profile', 'router', 'client']
}

const persistedReducer = persistReducer(
  persistConfig,
  employerSide ? reducers_employer : reducers
)
const store = createStoreWithMiddleware(persistedReducer, initialState)

if (employerSide) {
  sagaMiddleware.run(rootSaga_employer)
} else {
  sagaMiddleware.run(rootSaga)
}

// sagaMiddleware.run(rootSaga)
// sagaMiddleware.run(rootSaga_employer)

export default store
export const history = createReduxHistory(store)
export const persistor = persistStore(store)
